import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Title = styled.h1`
  font-size: ${(props) => props.theme.font.textbase};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
`

interface BoxProps {
  padding?: string
}

export const Box = styled.div<BoxProps>`
  background: ${(props) => props.theme.color.neutral.white};
  border-radius: ${(props) => props.theme.border.radius};
  border: 1px solid rgba(73, 73, 73, 0.3);
  padding: ${(props) => (props.padding ? props.padding : '0.5rem 1rem')};
  overflow: hidden;
`

export const LabelsContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`

interface LabelsProps {
  color: string
}

export const Labels = styled.div<LabelsProps>`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.25rem 1rem;
  border: 1px solid ${(props) => props.color};
  border-radius: ${(props) => props.theme.border.radius};
  font-size: ${(props) => props.theme.font.textsm};
`

export const LabelBullet = styled.span<LabelsProps>`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`

export const FiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`

export const ButtonContainer = styled.div`
  align-self: flex-end;
  min-width: 15%;
  max-width: 30%;
`

export const TableFilter = styled.div`
  /* display: flex; */
  max-width: 50%;
  align-items: center;
  justify-self: self-end;
  gap: 1rem;
`

export const Row = styled.div`
  display: flex;
  gap: 1rem;
`

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 30px;
  width: 100%;
  > thead {
    position: sticky;
    top: 0;
    background: #fff;
    > hr {
      width: 100%;
      margin: 0;
    }
  }
  > tbody {
    tr {
      background: #fff;
      border-spacing: 1em 0.5em;
      padding: 0 2em 1em 0;
      border: 3px solid #ffffff;
    }
    tr:nth-child(even) {
      background-color: #d6eeee;
    }
  }
`

export const TableHeader = styled.th`
  padding: 8px;
  text-align: left;
  font-size: ${(props) => props.theme.font.textsm};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
  letter-spacing: 0.00938rem;
`

export const TableCell = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
`

export const TableCellEmpty = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
  text-align: center;
`

interface StatusBoxProps {
  status: string
}

export const StatusBox = styled.div<StatusBoxProps>`
  color: ${(props) => props.theme.color.neutral.white};
  background-color: ${(props) =>
    props.status === 'ABERTO'
      ? props.theme.color.red.red600
      : props.theme.color.purple.purple600};
  padding: 0.5rem;
  border-radius: ${(props) => props.theme.border.radius};
  text-align: center;
  font-size: ${(props) => props.theme.font.textcaption};
  white-space: nowrap;
  cursor: default;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: end;
  width: 50%;
  gap: 1rem;
  cursor: pointer;
`

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
`

interface CheckboxProps {
  isChecked: boolean
}

export const CheckboxAppearence = styled.label<CheckboxProps>`
  min-width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #cecece;
  background: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: ${(props) => (props.isChecked ? 'flex' : 'none')};
    filter: invert(75%) sepia(11%) saturate(6042%) hue- rotate(30deg)
      brightness(105%) contrast(68%);
  }
`

export const Divider = styled.div`
  background-color: ${(props) => props.theme.color.neutral.background};
  height: 1.38rem;
  width: 200%;
`

export const BoxText = styled.textarea<BoxProps>`
  background: ${(props) => props.theme.color.neutral.white};
  border-radius: ${(props) => props.theme.border.radius};
  border: 1px solid rgba(73, 73, 73, 0.3);
  padding: 15px;
  overflow: hidden;
  height: 25vh;
  margin: 0.5rem

  font-size: ${(props) => props.theme.font.textbase};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;

  
`
